import React from "react";
import logo from "../images/logo.jpg";

const Logo = () => (
  <div className="logo-pic">
    <img src={logo} alt="logo" />
  </div>
);
export default Logo;